export const CHANGE_PLAN_LOADING_STATES = {
    GET_USER_PLAN_EXPIRY_DATE_LOADING: "GET_USER_PLAN_EXPIRY_DATE_LOADING",
    GET_USER_PLAN_EXPIRY_DATE_READY: "GET_USER_PLAN_EXPIRY_DATE_READY"
}